import {
  SimpleForm,
  TextField,
  DateField,
  ReferenceField,
  Show,
  ShowProps,
  DeleteButton
} from 'react-admin';
import MuiToolbar from '@material-ui/core/Toolbar';
import { AdminTitle, formWrapper } from '../../components';

const FormWrapper = (props: ShowProps) => formWrapper({ ...props, mutationMode: 'pessimistic' })(Show)

const Toolbar = (props) => (
  <MuiToolbar>
    <DeleteButton {...props} />
  </MuiToolbar>
)

export default function MessagesShow(props: ShowProps) {
  return (
    <>
      <AdminTitle />
      <FormWrapper {...props}>
        <SimpleForm toolbar={<Toolbar />}>
          <DateField 
            locales="pt-BR" 
            options={{ timeZone: 'UTC' }} 
            source="createdAt" 
            label="Enviada em" 
          />
          <TextField source="name" label="Nome" />
          <TextField source="email" label="E-mail" />
          <TextField source="phone" label="Telefone" />
          <ReferenceField
            label="Assunto"
            source="subject"
            reference="message-subjects"
            link={false}
          >
            <TextField source="name" />
          </ReferenceField>

          <TextField source="text" label="Mensagem" />
        </SimpleForm>
      </FormWrapper>
    </>
  );
}
